import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import outair_threshold from '../entities/outair_threshold'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface outair_thresholdState extends ListState<outair_threshold>{
    editoutair_threshold:outair_threshold
}
class UserMutations extends ListMutations<outair_threshold>{

}
class Outair_ThresholdModule extends ListModule<outair_thresholdState,any,outair_threshold>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<outair_threshold>(),
        filterlist:new Array<outair_threshold>(),
        loading:false,
        editoutair_threshold:new outair_threshold()
    }
    actions={
        async getAll(context:ActionContext<outair_thresholdState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/OutairThreshold/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<outair_threshold>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            context.state.filterlist=page.items;
        },
        async getPaged(context:ActionContext<outair_thresholdState,any>,payload:any){
          
            context.state.loading=true;
            //debugger
            let reponse=await Ajax.get('/api/services/app/OutairThreshold/GetPaged',{params:payload.data});
            
            context.state.loading=false;
            let page=reponse.data.result as PageResult<outair_threshold>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            context.state.filterlist=page.items;
        },
        async getfilter(context:ActionContext<outair_thresholdState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/OutairThreshold/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<outair_threshold>;
            context.state.totalCount=page.totalCount;
            context.state.filterlist=page.items;
        },
        async create(context:ActionContext<outair_thresholdState,any>,payload:any){
            await Ajax.post('/api/services/app/OutairThreshold/Create',payload.data);
        },
        async uploadimg(context:ActionContext<outair_thresholdState,any>,payload:any){
            //console.log(payload.data.UploadData);
            await Ajax.post('/api/services/app/UploadFile/UploadFile',{params:payload.data.UploadData});
        },
        async update(context:ActionContext<outair_thresholdState,any>,payload:any){
            await Ajax.put('/api/services/app/OutairThreshold/Update',payload.data);
        },
        async delete(context:ActionContext<outair_thresholdState,any>,payload:any){
            await Ajax.delete('/api/services/app/OutairThreshold/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<outair_thresholdState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/OutairThreshold/GetById?Id='+payload.id);
            return reponse.data.result as outair_threshold;
        }
    };
    mutations={
        setCurrentPage(state:outair_thresholdState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:outair_thresholdState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:outair_thresholdState,outair_threshold:outair_threshold){
            
            state.editoutair_threshold=outair_threshold;
            //console.log(state.editFloor);
        }
    }
}
const outair_thresholdModule=new Outair_ThresholdModule();
export default outair_thresholdModule;